//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTime } from '../../components/helpers.js'
import { EventBus } from '../../EventBus/EventBus.js'

import { ACTIONS, getMaintenanceNoteStatusColor } from './ServiceObjectMaintenanceNote.js'
import { TABLE_COLUMNS, TABLE_COLUMNS_MOBILE, loadNotes } from './ServiceObjectMaintenanceNotesTable.js'
import ServiceObjectMaintenanceNoteOperation from './ServiceObjectMaintenanceNoteOperation.vue'
import Table from '../../components/Table/Table.vue'
import TableCellObject from '../../components/Table/TableCellObject.vue'
import ReadonlyDocumentsField from '../../components/File/ReadonlyDocumentsField.vue'

export default {
  components: {
    Table,
    TableCellObject,
    ReadonlyDocumentsField
  },
  props: {
    sourceProps: {
      type: Object,
      default: function () {
        return null
      }
    },
    report: {
      type: Object,
      default: function () {
        return null
      }
    },
    displayLabel: {
      type: Boolean,
      default: false
    },
    useMobileLayout: {
      type: Boolean,
      default: false
    },
    simpleMobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      notes: [],
      formatTime: formatTime,
      showFixed: false,
      showCanceled: false,
      loading: false
    }
  },
  computed: {
    filteredNotes: function () {
      let filteredNotes = this.notes
      if (!this.showFixed) {
        filteredNotes = filteredNotes.filter(note => !note.maintenanceNoteStatus || note.maintenanceNoteStatus.key !== 'fixed')
      }
      if (!this.showCanceled) {
        filteredNotes = filteredNotes.filter(note => !note.maintenanceNoteStatus || note.maintenanceNoteStatus.key !== 'canceled')
      }
      return filteredNotes
    },
    hasCanceledNotes: function () {
      return !!this.notes.find(note => note.maintenanceNoteStatus && note.maintenanceNoteStatus.key === 'canceled')
    },
    hasFixedNotes: function () {
      return !!this.notes.find(note => note.maintenanceNoteStatus && note.maintenanceNoteStatus.key === 'fixed')
    },
    hasNotFixedNotes: function () {
      return !!this.notes.find(note => note.maintenanceNoteStatus && note.maintenanceNoteStatus.key === 'notFixed')
    },
    access: function () {
      // TODO role operation

      const user = this.$store.getters.getUser
      return user.hasUIAccess('serviceObject.maintenanceNote.edit')
    },
    columns: function () {
      let columns = this.mobile ? TABLE_COLUMNS_MOBILE : TABLE_COLUMNS

      // simpleMobile (оповещение в отчете бригадиру)
      if (this.simpleMobile) {
        columns = columns.filter(col => col.name === 'state' || col.name === 'maintenanceNoteType' || col.name === 'description' || col.name === 'files')
      }

      // Только в журнале тип объекта
      columns = columns.filter(col => col.name !== 'serviceObjectType')

      // Только для станции метро (потому что раздельно на камеру замечание)
      if (this.sourceProps.serviceObjectType !== 'stationMetro') {
        columns = columns.filter(col => col.name !== 'serviceObject')
      }

      return columns
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile' || this.useMobileLayout
    },
    camMetroResultValue: function () {
      if (this.report) {
        let camMetroResult = {}
        const allWorks = [...this.report.workTypes]
        for (let i = 0; i < this.report.workPackages.length; i++) {
          this.report.workPackages[i].workTypes.forEach((work) => {
            allWorks.push(work)
          })
        }
        for (const work of allWorks) {
          for (const technologicalOperation of work.technologicalOperations) {
            for (const workResultsType of technologicalOperation.workResultsTypes) {
              for (const resultValue of workResultsType.resultValues) {
                if (resultValue.fieldType == 'formdata' && resultValue.formType == 'camMetroResult') {
                  camMetroResult = resultValue
                }
              }
            }
          }
        }
        return camMetroResult.value || []
      } else {
        return []
      }
    }
  },
  watch: {
    notes: {
      handler: function () {
        for (let i = 0; i < this.notes.length; i++) {
          const note = this.notes[i]
          if (note.photos) {
            this.$set(note, 'files', [])

            for (let j = 0; j < note.photos.length; j++) {
              const fileId = note.photos[j]
              note.files.push({
                name: 'Замечание к объекту' + '-' + fileId,
                id: fileId
              })
            }
          }

          if (note.lastOperationFileIds) {
            this.$set(note, 'lastOperationFiles', [])

            for (let j = 0; j < note.lastOperationFileIds.length; j++) {
              const fileId = note.lastOperationFileIds[j]
              note.lastOperationFiles.push({
                name: 'Замечание к объекту' + '-' + fileId,
                id: fileId
              })
            }
          }
        }
      },
      immediate: true
    },
    'sourceProps.id': {
      handler: function (value) {
        if (value) {
          this.updateNotes()
        }
      }
    }
  },
  created: function () {
    const showFixed = localStorage.getItem('serviceObjectMaintenanceNotesTableShowFixed')
    if (showFixed && (showFixed === 'true' || showFixed === 'false')) {
      this.showFixed = JSON.parse(showFixed)
    }
    const showCanceled = localStorage.getItem('serviceObjectMaintenanceNotesTableShowCanceled')
    if (showCanceled && (showCanceled === 'true' || showCanceled === 'false')) {
      this.showCanceled = JSON.parse(showCanceled)
    }

    EventBus.$on('update-notes', this.updateNotes)
    this.updateNotes()
  },
  beforeDestroy: function () {
    EventBus.$off('update-notes', this.updateNotes)
  },
  methods: {
    showColumnMobile: function (col) {
      const val = col.value
      const hasColumnValue = val != null && !!val && val.length > 0 && val !== 'Нет'
      return hasColumnValue
    },
    displayBtnFixNote: function (record) {
      if (!record.canBeClosed) {
        return false
      }
      if (record.hasIncident && (record.incidentData.requestToCheck || record.incidentData.problemStatus !== 'opened')) {
        return false
      }
      return record.maintenanceNoteStatus && record.maintenanceNoteStatus.key === 'notFixed' && !this.simpleMobile
    },
    hasCamMetroInCheckList: function (cam) {
      return this.camMetroResultValue && this.camMetroResultValue.some(tg => tg.cams && tg.cams.some(c => c.camId === cam.key) || tg.subgroups && tg.subgroups.cams && tg.subgroups.cams.some(c => c.camId === cam.key))
    },
    onNoteFixed: function (note) {
      this.$d.dialog(this).show({
        maximized: false,
        persistent: true,
        headerHidden: true,
        contentComponent: ServiceObjectMaintenanceNoteOperation,
        contentProps: {
          recordId: note.id,
          record: note,
          action: ACTIONS.find(action => action.key === 'fix'),
          sourceProps: this.sourceProps
        },
        componentHandlers: {
          cancel: () => {
          },
          update: () => {
            this.updateNotes()
          }
        }
      })
    },
    updateNotes: function () {
      this.loading = true
      loadNotes(this.sourceProps)
        .then(notes => {
          this.notes = notes
          if (!this.showFixed) {
            this.showFixed = notes.filter(note => note.maintenanceNoteStatus && note.maintenanceNoteStatus.key === 'notFixed').length === 0
          }
          if (this.report) {
            this.$set(this.report, 'maintenanceNotes', notes)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    onChangeShowFixed: function (value) {
      localStorage.setItem('serviceObjectMaintenanceNotesTableShowFixed', value)
    },
    onChangeShowCanceled: function (value) {
      localStorage.setItem('serviceObjectMaintenanceNotesTableShowCanceled', value)
    },
    onCreate: function () {
      this.$router.push({ name: 'serviceObjectMaintenanceNoteCreate', params: { sourceProps: this.sourceProps } })
    },
    hasValue: function (col, note) {
      return col.hasValue ? col.hasValue(this.getValue(col, note)) : !!this.getValue(col, note)
    },
    getValue: function (col, note) {
      return col.format ? col.format(note[col.field], note) : note[col.field]
    },
    isFirstSection: function (col, note) {
      return this.columns.filter(col => this.hasValue(col, note)).indexOf(col) === 0
    },
    getTdClass: function (col, row) {
      if (col.name === 'maintenanceNoteStatus') {
        const color = getMaintenanceNoteStatusColor(row.maintenanceNoteStatus)
        if (color) {
          return 'text-bold text-white bg-' + color
        } else {
          return 'bg-white'
        }
      }
    },
    onScrollToCheckListCamMetro (note) {
      const reportCheckListEl = document.getElementById('report-check-list')
      const _reportWorkPackages = reportCheckListEl && reportCheckListEl.__vue__.$refs.reportWorkPackage && reportCheckListEl.__vue__.$refs.reportWorkPackage

      for (let i = 0; i < _reportWorkPackages.length; i++) {
        _reportWorkPackages[i].openWorkPackageFn(true)
      }

      this.$nextTick(() => {
        this.$nextTick(() => {
          const camMetroEls = document.getElementById('cam-metro')
          const _camMetro = camMetroEls && camMetroEls.__vue__
          if (_camMetro) {
            _camMetro.openAllMethod(true)
            this.$nextTick(() => {
              const camEl = document.getElementById(note.serviceObject.key)
              setTimeout(() => {
                if (camEl) {
                  camEl.scrollIntoView(false)
                }
              }, 100)
            })
          }
        })
      })
    }
  }
}
